import React, { useState } from 'react'
import { connect } from 'react-redux'

import UploadModal from 'pages/files/upload'

import style from './style.module.scss'

const mapStateToProps = ({ settings }) => ({ settings })

const SupportChat = () => {
  const [modal, setModal] = useState(false)

  return (
    <div className={style.chat}>
      <button onClick={setModal} type="button" className={style.toggleButton}>
        <i className={`${style.icon} fe fe-plus me-md-2`} />
        <span className="d-none d-md-inline">UPLOAD FILE</span>
      </button>
      <UploadModal open={modal} setOpen={setModal} />
    </div>
  )
}

export default connect(mapStateToProps)(SupportChat)
